// extracted by mini-css-extract-plugin
export var button = "LatestUpdates-module--button--35f82";
export var container = "LatestUpdates-module--container--02af0";
export var heading = "LatestUpdates-module--heading--3ae44";
export var root = "LatestUpdates-module--root--b9eb0";
export var slider = "LatestUpdates-module--slider--d13fe";